import { render } from "./LetterFTranscription.vue?vue&type=template&id=1fd44110&scoped=true"
import script from "./LetterFTranscription.vue?vue&type=script&lang=js"
export * from "./LetterFTranscription.vue?vue&type=script&lang=js"

import "./LetterFTranscription.vue?vue&type=style&index=0&id=1fd44110&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd44110"]])

export default __exports__